import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken.jsx';

const findLecture = async (pageId) => {
    if (!pageId) {
        throw new Error("Invalid pageId");
    }

    try {
        const accessToken = await retrieveAccessToken({ required: false });
        
        const response = await axios.get(`/api/viewer/page/${pageId}`, {
            headers: {
                ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
            }
        });
        if (!response.data) {
            throw new Error("No data received");
        }
        return response.data;
    } catch (error) {
        throw new Error(
            error.response
                ? `Error fetching page: ${error.response.status} ${error.response.statusText}`
                : error.message
        );
    }
};

export { findLecture };
